<template>
	<div class="main">
		<div v-show="!detialshow">
      <Table
        :columns="columns"
        row-key="id"
        :request="request"
        :searchData ="searchData"
        :params="{status:'3',type:'5'}" 
        :formData="formData"
        :mulselect="true"
		ref="tableref"
      >
       <template v-slot:formItem>
           <a-form-model-item >
               <a-input style="width:150px"  v-model="searchData.name" allowClear  placeholder="请输入合同名称"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-input style="width:100px" v-model="searchData.yi" allowClear  placeholder="乙方姓名"/>
           </a-form-model-item> 
           <a-form-model-item >
               <a-input style="width:130px" v-model="searchData.yiPhone" allowClear  placeholder="乙方电话"/>
           </a-form-model-item>
           <a-form-model-item >
               <a-input style="width:130px" v-model="searchData.yiIdCard" allowClear  placeholder="乙方身份证号码"/>
           </a-form-model-item>
			<a-form-model-item >
               <a-select style="width:130px" v-model="searchData.yiWorkPlace" allowClear  placeholder="乙方所在工地" @change="workplacechange" >
				   <a-select-option v-for="item in workplaceArray" :key="item.id" :value="item.id" :text="item.name">{{item.name}}</a-select-option>
			   </a-select>
           </a-form-model-item> 
		   <a-form-model-item>
			   <a-date-picker style="width:120px" v-model="searchData.tt1" allowClear placeholder="开始时间" ></a-date-picker>
		   </a-form-model-item>
		   <a-form-model-item>
			   <a-date-picker style="width:120px" v-model="searchData.tt2" allowClear placeholder="结束时间" ></a-date-picker>
		   </a-form-model-item>
       </template>

	    <template v-slot:tableAction="{record,showModal,showDelConfirm}">
		   <a class="tAction" @click="godetial(record)"><a-icon type="vertical-align-bottom" /> 查看导出</a>
           <a-divider type="vertical" />
           <a class="tAction" @click="Delete(record,showDelConfirm)"><a-icon type="delete" /> 删 除</a>
        </template>
	    <template v-slot:otherBarOperation>
			<a-form-model-item>
				<downloadexcel
					class="ant-btn ant-btn-primary export-btn"
					:fetch="getdataSource"
					:fields="excelheader"
					:before-finish="exportsuccess"
					name="本页数据.xls"
				>导出本页数据</downloadexcel>
			</a-form-model-item>
			<a-form-model-item>
				<downloadexcel
					class="ant-btn ant-btn-primary export-btn"
					:fields="excelheader"
					:fetch="getAllData"
					:before-finish="exportsuccess"
					name="全部数据.xls"
				>导出全部数据</downloadexcel>
				</a-form-model-item>
			</template>
       		<template v-slot:totalinfo="{tabledata}">
           		<div class="totalinfo">
					<a-tag color="blue">
						<span style="font-size:15px;padding:5px;display:inline-block">
						   <strong>本页金额:</strong> {{getTotalMoney(tabledata).pagesum}} 元	
						</span>
						<span style="font-size:15px;padding:5px;display:inline-block">
						   <strong>总金额:</strong> {{getTotalMoney(tabledata).pricesum}} 元	
						</span>
					</a-tag>
				</div>
			</template>
      </Table>
		</div>
		<div v-if="detialshow">
			<Detial :id="detialId" @backfn="backdetial"></Detial>
		</div>
	</div>
</template>

<script>
import ContractFinish from "./index.js"
export default ContractFinish
</script>

<style lang="less" scoped>
	.export-btn{
		line-height: 30px;
	}
	.totalinfo{
        margin: 0px 0px 10px 20px;
        display: flex;
        justify-content: flex-start;
    }
</style>

